/**
 * True when this penrose-web build is the one bundled into the Penrose IDE.
 * Set at build time via `VITE_IS_IDE=true` by the IDE's bundle script
 * (`penrose-ide/electron-app/scripts/bundle-penrose-web.js`). The normal
 * penrose-web web build never sets it, so this is `false` there.
 *
 * All IDE-conditional code MUST read this helper — never `import.meta.env`
 * directly — so the gate has a single definition.
 */
export function isIDE(): boolean {
  return import.meta.env.VITE_IS_IDE === 'true';
}
